import axios from "axios";

//state
export var campaignState = {
  campaign: {},
  campaigns: [],
  status_campaigns: "",
  proposals:[],
};

//getters
export var campaignGetters = {
  //funciones para optener informacion del state
  getCampaign: state => state.campaign,
  getCampaigns: state => state.campaigns,
  getProposals: state => state.proposals,
};

//actions
export var campaignAcctions = {
  async getCampaign({ commit }) {
    commit("campaign_request");
    await axios
      .get("https://jsonplaceholder.typicode.com/posts?userId=1")
      .then(res => {
        const campaign = {
          id: 2,
          nombre: "Apache navidad",
          creada: "2012/01/01",
          costos: "0.92$ por click",
          acciones: {
            disponible: true,
            editar: true,
            eliminar: true
          },
          alcance: 2000,
          status: "Active"
        };
        commit("campaign_success", campaign);
        return campaign;
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async getCampaignsTruly({ commit }) {
    commit("campaign_request");
    await this._vm.$http
      .get("apache/rest_api/campaign/", {
        headers: {
          fields: { status: "ACTIVE" }
        }
      })
      .then(res => {
      })
      .catch(err => {
        console.log(err);
        commit("campaign_error");
        return err;
      });
  },
  async getProposals({commit,state}) {
    commit("campaign_request");
    await axios
      .get("/apache/rest_api/apache.proposal", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: '["id","name"]'
        }
      })
      .then(res => {
        var proposals = res.data;
        commit("proposal_success", proposals);
        return res;
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async getCampaigns({ commit,state }) {
    var access_token = state.api_token_facebook
    commit("campaign_request");
    await axios
      .get("/apache/rest_api/apache.campaign", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: '["id",'+
          '"name",'+
          '"geo_based_in",'+
          '"bid_strategy",'+
          '"daily_budget",'+
          '"lifetime_budget",'+
          '"start_date",'+
          '"end_date",'+
          '"create_time",'+
          '"status",'+
          '"state",'+
          '("objective_id",["id", "name"]),'+
          '("partner_id",["id", "name"]),'+
          '("pixel_id",["id", "pixel_code"]),'+
          '("app_id",["id", "name"]),'+
          '("page_id",["id", "name"]),'+
          '("proposal_id",["id", "name"]),'+
          '("promotion_id",["id", "name"]),'+
          '("account_id",["id", "name"]),'+
          '"is_imported"]'
        }
      })
      .then(res => {
        var campaigns = res.data;
        commit("campaigns_success", campaigns);
        return res;
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async newCampaign({ commit, state }, campaign) {
    commit("campaign_request");
    var {
      promotion_id,
      pixel_id,
      proposal_id,
      account_id,
      partner_id,
      page_id,
      geo_based_in,
      name,
      objective_id,
      status,
      bid_strategy,
      daily_budget,
      lifetime_budget,
      start_date,
      end_date,
      app_id,
    } = campaign;
    var formData = new FormData();
    var new_campaign = `{
      'bid_strategy': '${bid_strategy.id}',
      'daily_budget':${daily_budget},
      'lifetime_budget':${lifetime_budget},
      'status':'${status.id}',
      'start_date': '${start_date}',
      'end_date': '${end_date}',
      'name': '${name}',
      'objective_id': ${objective_id.id},
      'account_id': ${account_id.id},
      'partner_id': ${partner_id.id},
      'pixel_id': ${pixel_id.id},
      'app_id': ${app_id.id},
      'page_id': ${page_id.id},
      'proposal_id': ${proposal_id.id},
      'promotion_id': ${promotion_id.id},
      'geo_based_in': '${geo_based_in.id}',
      'relational_fields': [
          ('promotion_id', 'apache.promotion'),
          ('page_id', 'apache.page'),
          ('app_id', 'apache.app'),
          ('proposal_id', 'apache.proposal'),
          ('pixel_id', 'apache.pixel'),
          ('account_id', 'apache.user.account'),
          ('partner_id', 'res.partner'),
          ('objective_id', 'apache.campaign.objective')
        ],
      }`;
    formData.append("data", new_campaign);
    await this._vm.$http
      .post("/apache/rest_api/apache.campaign", formData, {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          var {campaigns} = state
          campaign.id = res.data.id;
          campaigns.push(campaign);
          commit("campaigns_success", campaigns);
          return campaigns;
        } else {
          commit("campaign_error");
        }
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async editCampaign({ commit, state }, campaign) {
    commit("campaign_request");
    var {
      id,
      account_id,
      partner_id,
      geo_based_in,
      name,
      objective_id,
      status,
      bid_strategy,
      daily_budget,
      lifetime_budget,
      start_date,
      end_date,
    } = campaign;
    var formData = new FormData();
    var new_campaign = `{
      'bid_strategy': '${bid_strategy.id}',
      'daily_budget':${daily_budget},
      'lifetime_budget':${lifetime_budget},
      'status':'${status.id}',
      'start_date': '${start_date}',
      'end_date': '${end_date}',
      'name': '${name}',
      'objective_id': ${objective_id.id},
      'account_id': ${account_id.id},
      'partner_id': ${partner_id.id},
      'geo_based_in': '${geo_based_in.id}',
      'relational_fields': [
          ('account_id', 'apache.user.account'),
          ('partner_id', 'res.partner'),
          ('objective_id', 'apache.campaign.objective')
            ],
      }`;
    formData.append("data", new_campaign);
    await this._vm.$http
      .put("/apache/rest_api/apache.campaign", formData, {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var {campaigns} = state;
          var index;
          for (var i = 0; i < campaigns.length; i++) {
            if (campaigns[i].id == id) {
              index = i;
              campaigns[i] = campaign;
              break;
            }
          }
          campaigns.splice(index, 1);
          campaigns.splice(index, 0, campaign);
          commit("campaigns_success", campaigns);
          return campaigns;
        } else {
          commit("campaign_error");
        }
      })
      .catch(err => {
        commit("campaign_error");
        return err;
      });
  },
  async deleteCampaign({ commit, state }, id) {
    commit("campaign_request");
    await this._vm.$http
    .delete(`/apache/rest_api/apache.campaign/${id}`, { 
      headers: {
          //"X-Odoo-dbfilter": "apachev1"
        }
      })
      .catch(err => {
        commit("partner_error");
        return err;
      });
  },
  async deleteCampaignUtility({ commit, state }, id) {
      commit("campaign_request");
      var index;
      var {campaigns} = state;
      for (var i = 0; i < campaigns.length; i++) {
        if (campaigns[i].id == id) {
          index = i;
          break;
        }
      }
      commit("campaign_delete_success", index);
      return campaigns;
  }
};

//mutations

export var campaignMutations = {
  campaign_request(state) {
    state.status_campaigns = "loading";
  },
  campaign_success(state, payload) {
    state.status_campaigns = "success";
    state.campaign = payload;
  },
  campaigns_success(state, payload) {
    state.status_campaigns = "success";
    state.campaigns = payload;
  },
  proposal_success(state, payload) {
    state.status_campaigns = "success";
    state.proposals = payload;
  },
  campaign_delete_success(state,payload) {
    state.status_ad_sets = "success";
    state.campaigns.splice(payload,1)
  },
  campaign_error(state) {
    state.status_campaigns = "error";
  }
};
